import { initializeApp, setLogLevel } from "firebase/app";
import {
  browserLocalPersistence,
  getAuth,
  setPersistence,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import {
  initializeFirestore,
  memoryLocalCache,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

export const setFirebaseLoggingEnabled = (enabled: boolean) => {
  setLogLevel(enabled ? "debug" : "silent");
};

// To enable verbose Firebase logs locally:
// localStorage.setItem('debugFirebase', '1')
// location.reload()
//
// To disable:
// localStorage.removeItem('debugFirebase')
// location.reload()
setFirebaseLoggingEnabled(
  import.meta.env.DEV && localStorage.getItem('debugFirebase') === '1'
);

export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  localCache: memoryLocalCache(),
});

const persistencePromise = setPersistence(auth, browserLocalPersistence);

export const signInWithEmail = async (email: string, password: string) => {
  try {
    await persistencePromise;

    console.info("AUTH INSTANCE:", auth);
    const result = await signInWithEmailAndPassword(auth, email, password);
    console.info("Signed in OK:", result.user);
    return result.user;
  } catch (error: any) {
    console.error("Error signing in", {
      code: error.code,
      message: error.message,
      customData: error.customData,
      full: error,
    });
    throw error;
  }
};

export const logout = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error("Error signing out", error);
    throw error;
  }
};
